var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTokenWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7915 34.375V76.125C19.7915 77.2296 20.6869 78.125 21.7915 78.125H78.2082C79.3127 78.125 80.2082 77.2296 80.2082 76.125V36.375C80.2082 35.2704 79.3127 34.375 78.2082 34.375H63.5415M19.7915 34.375V23.875C19.7915 22.7704 20.6869 21.875 21.7915 21.875H61.5415C62.6461 21.875 63.5415 22.7704 63.5415 23.875V34.375M19.7915 34.375H63.5415",
    stroke: "#FFB000",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.375 56.25L67.7083 56.25",
    stroke: "#FFB000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenWallet);
export default __webpack_public_path__ + "static/media/token-wallet.bae22a804e6e53efc46e224bf88345f7.svg";
export { ForwardRef as ReactComponent };